export const visit = (vm, at) => {
at({ "et": { "sanitizedEmail": { "imageError": "See pilt on kuvamiseks liiga suur.", "expandEmailButtonText": "Laienda", "collapseEmailButtonText": "V\xE4henda", "hideEmailRepliesButtonText": "Peida k\xE4rbitud sisu", "showEmailRepliesButtonText": "Kuva k\xE4rbitud sisu" } } });
};